<ng-container *ngIf="isBrowser">
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title">Tarifklasse</span>
        <div class="tmp-section-body tmp-flexy">
            <button class="tmp-f-btn" [class.tmp-f-btn-selected]="currentTarif === 'SPAR'" (click)="selectTarif('SPAR')" matRipple>Sparpreis</button>
            <button class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="currentTarif === 'FLEX'" (click)="selectTarif('FLEX')" matRipple>Flexpreis</button>
        </div>
    </div>
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title">Wagenklasse</span>
        <div class="tmp-section-body tmp-flexy">
            <button class="tmp-f-btn" [class.tmp-f-btn-selected]="currentWagenClass === '1'" (click)="selectbookingClass('1')" matRipple>1. Klasse</button>
            <button class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="currentWagenClass === '2'" (click)="selectbookingClass('2')" matRipple>2. Klasse</button>
        </div>
    </div>
</ng-container>